import React from "react";
import { Drawer } from "antd";

const AntDDrawer = ({
  show = false,
  onClose,
  title = "",
  placement = "right", // Drawer Placement
  width = 500, // Drawer Width
  height, // Drawer Height
  footer = null, // Drawer Footer
  backdrop = false, // true | false | "static" (Click on backdrop to close)
  keyboard = false, // true | false (Press Esc to close)
  className = "",
  children,
  ...rest
}) => {
  const maskClosable = backdrop === "static" ? false : backdrop;

  return (
    <Drawer
      open={show}
      onClose={onClose}
      title={title}
      placement={placement}
      width={placement === "left" || placement === "right" ? width : undefined}
      height={placement === "top" || placement === "bottom" ? height : undefined}
      footer={footer}
      maskClosable={maskClosable}
      keyboard={keyboard}
      className={`SwAntDDrawer ${className}`}
      {...rest}
    >
      {children}
    </Drawer>
  );
};

export default AntDDrawer;
